var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _rect, _tspan10, _tspan11, _tspan12, _tspan13, _rect2, _ellipse, _tspan14, _g, _ellipse2, _path, _path2, _rect3, _tspan15, _rect4, _rect5, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLegendsJesus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    width: 400,
    height: 650,
    viewBox: "0 0 105.83 171.98",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title4879"
  }, "legend-Jesus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title4879"
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    fontFamily: "sans-serif",
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("text", {
    id: "text186",
    x: 3.1076226,
    y: 15.538118,
    fontSize: "10.583px",
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan184",
    x: 3.1076226,
    y: 15.538118,
    strokeWidth: 0.26458
  }, "KEY"))), /*#__PURE__*/React.createElement("g", {
    fontSize: "4.2333px"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text190",
    x: 19.165756,
    y: 27.937403,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan188",
    x: 19.165756,
    y: 27.937403
  }, "Ruled by Herod Archelaus, later")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan8937",
    x: 19.165756,
    y: 33.229065
  }, "by Roman Governor Pontius Pilate"))), /*#__PURE__*/React.createElement("text", {
    id: "text194",
    x: 18.943783,
    y: 40.330212,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan192",
    x: 18.943783,
    y: 40.330212,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Ruled by Herod Antipas"))), /*#__PURE__*/React.createElement("text", {
    id: "text202",
    x: 18.943783,
    y: 60.216339,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan200",
    x: 18.943783,
    y: 60.216339,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Location Reasonably Certain"))), /*#__PURE__*/React.createElement("text", {
    id: "text206",
    x: 18.943783,
    y: 69.133659,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan204",
    x: 18.943783,
    y: 69.133659,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Location Less Certain"))), /*#__PURE__*/React.createElement("text", {
    id: "text210",
    x: 18.943783,
    y: 78.098518,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan208",
    x: 18.943783,
    y: 78.098518,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Mountain"))), /*#__PURE__*/React.createElement("text", {
    id: "text214",
    x: 18.943783,
    y: 96.216339,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan212",
    x: 18.943783,
    y: 96.216339,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Precise Location Unknown"))), /*#__PURE__*/React.createElement("text", {
    id: "text218",
    x: 18.943783,
    y: 105.21634,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan216",
    x: 18.943783,
    y: 105.21634,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Road"))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect430",
    x: 0.01731,
    y: 18.646,
    width: 105.81,
    height: 0.88789,
    strokeLinejoin: "bevel",
    strokeWidth: 0.4704
  })), /*#__PURE__*/React.createElement("text", {
    id: "text538",
    x: 6.9462566,
    y: 114.23701,
    fontFamily: "sans-serif",
    fontSize: "4.2333px",
    strokeWidth: 0.26458,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan536",
    x: 6.9462566,
    y: 114.23701
  }, "Alternative location names from same")), _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan540",
    x: 6.9462566,
    y: 119.52867
  }, "time period are separated by a comma"))), /*#__PURE__*/React.createElement("text", {
    id: "text538-4",
    x: 6.9462566,
    y: 126.99825,
    fontFamily: "sans-serif",
    fontSize: "4.2333px",
    strokeWidth: 0.26458,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan540-5",
    x: 6.9462566,
    y: 126.99825
  }, "Alternative location names from different")), _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan576",
    x: 6.9462566,
    y: 132.28992
  }, "time periods are in parentheses"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "rect430-7",
    x: -0.075882,
    y: 140.36,
    width: 105.81,
    height: 0.88789,
    strokeLinejoin: "bevel",
    strokeWidth: 0.4704
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "circle602",
    cx: 14.595,
    cy: 58.789,
    rx: 1.3891,
    ry: 1.3891,
    stroke: "#000000",
    strokeWidth: 0.39688
  })), /*#__PURE__*/React.createElement("text", {
    id: "text202-0",
    x: 18.683722,
    y: 87.237007,
    fontFamily: "sans-serif",
    fontSize: "4.2333px",
    strokeWidth: 0.26458,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan200-4",
    x: 18.683722,
    y: 87.237007,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Cities of the Decapolis")))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1198",
    transform: "matrix(.69377 0 0 .69377 12.278 92.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1196",
    d: "m2.446 3.7472q-.027905-.080615-.049609-.20774-.021704-.13022-.021704-.25735 0-.19844.077515-.35657.080615-.16123.19844-.30076.11782-.13953.25735-.26665.13953-.13022.25735-.26045.11782-.13333.19534-.27595.080615-.14573.080615-.31936 0-.14883-.058911-.26355-.05581-.11472-.15503-.19224-.099219-.077515-.22944-.11472-.13022-.040308-.27595-.040308-.524 0-.90847.41238v-.5457q.47439-.29766.98289-.29766.23564 0 .44338.062012.20774.062012.36277.18604.15813.12092.24805.30386.089917.18293.089917.42478 0 .22944-.080615.40928-.080616.17983-.20464.33176-.12092.14883-.26355.27905-.14263.13022-.26665.26045-.12092.12712-.20154.26665-.080615.13953-.080615.30696 0 .14263.034106.26045.034107.11472.068213.19534zm.27905 1.2898q-.13643 0-.24185-.099219-.10232-.099219-.10232-.24185 0-.14573.10232-.24185.10232-.10232.24185-.10232t.24185.10232q.10232.096118.10232.24185 0 .14263-.10232.24185-.10542.099219-.24185.099219z",
    fill: "#000000"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "circle1352",
    cx: 14.595,
    cy: 67.836,
    rx: 1.3891,
    ry: 1.3891,
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 0.39688
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1550",
    d: "m14.883 75.074c-.0866 0-.11545.05773-.17318.11545l-1.6741 2.742c-.02886.02887-.02886.08659-.02886.11545 0 .14432.11545.20204.20204.20204h3.3482c.11546 0 .20205-.05773.20205-.20204 0-.05773 0-.05773-.02886-.11545l-1.6452-2.742c-.05773-.05773-.11545-.11545-.20204-.11545zm0 .43296.9525 1.5875h-.23091l-.43296-.43296-.28864.43296-.28864-.43296-.43295.43296h-.25977z",
    fill: "#826539",
    strokeWidth: 0.28864
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1936-6",
    className: "UnoptimicedTransforms",
    transform: "matrix(-.0635 0 0 -.064384 18.979 107.17)",
    d: "m77.392 69.265s-15.035-16.417-25.007-16.417c-9.9713-1e-6-25.007 16.417-25.007 16.417v-22.66s15.561-13.328 25.007-13.328c9.4456 0 25.007 13.328 25.007 13.328zm-.02723-22.662s15.035 16.417 25.007 16.417c9.9713 1e-6 25.007-16.417 25.007-16.417v22.66s-15.561 13.328-25.007 13.328c-9.4455 0-25.007-13.328-25.007-13.328z",
    fill: "#a05a2c",
    strokeLinejoin: "bevel",
    strokeWidth: 0.98452
  })), /*#__PURE__*/React.createElement("text", {
    id: "text4743",
    transform: "scale(.26458)",
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "40px",
    style: {
      lineHeight: 1.25,
      shapeInside: "url(#rect4745)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "rect693",
    x: 12.175,
    y: 36.74,
    width: 4.3947,
    height: 4.5055,
    fill: "none",
    stroke: "#ccadc1",
    strokeLinejoin: "round",
    strokeWidth: 0.79375
  })), /*#__PURE__*/React.createElement("text", {
    id: "text194-0",
    x: 18.634392,
    y: 50.058491,
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "4.2333px",
    strokeWidth: 0.26458,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan192-0",
    x: 18.634392,
    y: 50.058491,
    fontSize: "4.2333px",
    strokeWidth: 0.26458
  }, "Ruled by Philip"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "rect693-5",
    x: 12.198,
    y: 46.887,
    width: 4.3947,
    height: 4.5055,
    fill: "none",
    stroke: "#dac459",
    strokeLinejoin: "round",
    strokeWidth: 0.79375
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "rect693-2",
    x: 12.175,
    y: 26.256,
    width: 4.3947,
    height: 4.5055,
    fill: "none",
    stroke: "#7cd0c2",
    strokeLinejoin: "round",
    strokeWidth: 0.79375
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "circle8393",
    cx: 14.588,
    cy: 85.856,
    r: 1.3891,
    fill: "#e6082d",
    stroke: "#e6082d",
    strokeWidth: 0.39687
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegendsJesus);
export default __webpack_public_path__ + "static/media/legends-Jesus.3a1b5d0716d7ef4321a4c59e812b1df9.svg";
export { ForwardRef as ReactComponent };